import React from 'react';
import {NCZIEntryInfo} from "../../../../Interfaces/ncziTypes";
import EHRCompositionInfo from "../EHRComposition/EHRCompositionInfo";

interface Props {
    info: NCZIEntryInfo | undefined
}

const EHREntryInfo: React.FC<Props> = (props) => {
    const {info} = props;

    if(!info) {
        return <></>;
    }

    return <EHRCompositionInfo info={info} />;
};

export default EHREntryInfo;
